// @ts-ignore
import ScannerDetector from 'js-scanner-detection';

const scanner = new ScannerDetector({
  onComplete: (code: string) => {
    // code = code.match(/CL\d+/g)?.[0];
    if (code) {
      const event = new CustomEvent('barcode', { detail: { code } });
      window.dispatchEvent(event);
    }
  },
});
